<div class="modal fade" id="performa_add_to_from_port_for" tabindex="1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered mw-650px">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<h2 class="fw-bold">Add Port</h2>
				<div data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
			</div>
			<div class="modal-body scroll-y">
				<form class="form" #portForm="ngForm" (ngSubmit)="onSubmit(portForm)">
					<div class="fv-row row">
						<div class="col-md-6 mb-5">
							<div class="fv-row row">
								<div class="col-md-4 d-flex align-items-center">
									<label for="country" class="fs-7 text-gray-600">Country <span class="text-danger">*</span></label>
								</div>
								<div class="col-md-8">
									<select
										class="form-select h-40px fs-7"
										name="country"
										id="country"
										[(ngModel)]="formData.country"
										required
										aria-label="Select Country">
										<option value="">Select Country</option>
										<option *ngFor="let country of countryList" [value]="country.code">{{ country.name }}</option>
									</select>
									<div *ngIf="portForm.submitted && !formData.country" class="text-danger fs-7 mt-1">
										Country is required
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 mb-5">
							<div class="fv-row row">
								<div class="col-md-4 d-flex align-items-center">
									<label for="portName" class="fs-7 text-gray-600">Port Name <span class="text-danger">*</span></label>
								</div>
								<div class="col-md-8">
									<input
										type="text"
										name="portName"
										id="portName"
										[(ngModel)]="formData.portName"
										required
										class="form-control h-40px fs-7"
										placeholder="Enter Port Name" />
									<div *ngIf="portForm.submitted && !formData.portName" class="text-danger fs-7 mt-1">
										Port name is required
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-end">
						<button type="button" class="btn btn-sm btn-light me-3" data-bs-dismiss="modal">Cancel</button>
						<button type="submit" class="btn btn-sm btn-primary indicator" [disabled]="isLoading">
							<span class="indicator-label" *ngIf="!isLoading">Add Port</span>
							<span class="indicator-progress" *ngIf="isLoading">Please wait...
								<span class="spinner-border spinner-border-sm align-middle ms-2"></span>
							</span>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>